// TMT SVG
jQuery($ => {
  const points = [
    [95.851, 432.863],
    [730.082, 656.33],
    [1206.588, 44.39],
    [1825.326, 111.284]
  ]

  const points2 = [
    [1260, 930],
    [330, 850],
    [1570, 136],
    [990, 140]
  ]

  const diffs = points.map(function (point, i) {
    const point2 = points2[i]
    return [
      point2[0] - point[0],
      point2[1] - point[1]
    ]
  })

  const pointByTime = (point, diff, time) => {
    return [
      point[0] + time * diff[0],
      point[1] + time * diff[1]
    ]
  }

  const pointsByTime = (points, diffs, times) => {
    return points.map((point, i) => {
      return pointByTime(point, diffs[i], times[i])
    })
  }

  const pointsToString = points => {
    const points2 = points.concat(points.slice(0, 1))
    return points2.map(x => x.join(' ')).join(' ')
  }

  const animDuration = 2 // sekunden

  const sin = function (time) { return (Math.sin((time - 0.25) * animDuration * Math.PI) + 1) / 2 }

  $('svg.animated').each(function () {
    //console.log($(this));
    //console.log($(this).find('polygon'));
    const $polygon = $(this).find('polygon').eq(0)

    function setPoints (time) {
      const realPoints = pointsByTime(
        points,
        diffs,
        [
          sin(time),
          //sin(time + 0.1),
          sin(time),
          sin(time),
          sin(time)
        ])
      $polygon.attr('points', pointsToString(realPoints))
    }

    const t = (new Date()) * 1
    function tick () {
      const timeElapsed = (new Date()) - t
      const time = (timeElapsed / 30 % 1000) / 1000
      setPoints(time)
      requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
  })
})


// WEBPACK FOOTER //
// ./js/parts/tmt-svg.js